// extracted by mini-css-extract-plugin
export default {"nft":"NFT_nft__meYO-"};